import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#FF8200',
            contrastText: '#000',
        },
        secondary: {
            main: '#8698C7',
            contrastText: '#000',
        },
        background: {
            default: '#1c1e22',
            paper: '#25282e',
        },
    },
    shape: {
        borderRadius: 8,
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            '"Fira Sans"',
            '"Droid Sans"',
            '"Helvetica Neue"',
            'sans-serif',
        ].join(','),
    },
    components: {
        MuiAppBar: {
            defaultProps: {
                color: 'default',
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#282c34',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});

export default theme;
